import ModulePay from '@/page/modules/pay/pay'
import ModuleWXPay from '@/page/modules/pay/wxPay'
import ModulePayResult from '@/page/modules/pay/result'
import Index from '@/page/entrain/index'
import Home from '@/page/entrain/home'

/* 企业内训机构管理org路由 */
import PageOrg from '@/page/entrain/org/index'
import PageOrgStructure from '@/page/byl/org/structure/index'
import PageOrgReports from '@/page/byl/org/reports/index'
import PageOrgExternals from '@/page/byl/org/externals/index'
import PageOrgGroup from '@/page/byl/org/group/index'
import PageOrgResource from '@/page/byl/org/resource/model'
import PageOrgResourceList from '@/page/byl/org/resource/list'
import PageOrgRepo from '@/page/byl/org/repo/model'
import PageOrgRepoList from '@/page/byl/org/repo/list'
import PageOrgTag from '@/page/byl/org/tag/model'
import PageOrgTagList from '@/page/byl/org/tag/list'
import PageOrgMsg from '@/page/byl/org/msg/model'
import PageOrgMsgList from '@/page/byl/org/msg/list'
import PageOrgCourse from '@/page/byl/org/course/model'
import PageOrgCourseList from '@/page/byl/org/course/list'
import PageOrgLivePlay from '@/page/byl/org/livePlay/model'
import PageOrgLivePlayList from '@/page/byl/org/livePlay/list'
import PageOrgBanner from '@/page/byl/org/banner/model'
import PageOrgBannerList from '@/page/byl/org/banner/list'
import PageMenu from '@/page/byl/org/orgmenu/model'
import PageMenuList from '@/page/byl/org/orgmenu/list'
import PageOrgRole from '@/page/byl/org/role/model'
import PageOrgRoleList from '@/page/byl/org/role/list'
import PageOrgRoleDistributeList from '@/page/byl/org/role/distribute'
import PageRole from '@/page/byl/org/orgrole/model'
import PageRoleList from '@/page/byl/org/orgrole/list'
import PageRoleDistributeList from '@/page/byl/org/orgrole/distribute'
import PageDictList from '@/page/byl/org/orgdict/list'
import PageDict from '@/page/byl/org/orgdict/model'
import PageOrgAppList from '@/page/byl/org/appmgt/list'
import PageOrgApp from '@/page/byl/org/appmgt/model'
/* 考试-考卷-考题-问卷--start */
import ModuleExamReady from '@/page/entrain/exam/ready'
import ModuleExamStart from '@/page/entrain/exam/start'
import ModuleExamAnalysis from '@/page/entrain/exam/analysis'
import ModuleExamResult from '@/page/entrain/exam/result'

import ModuleQuestionnaireStart from '@/page/entrain/questionnaire/start'
import ModuleQuestionnaireResult from '@/page/entrain/questionnaire/result'

import PageOrgExamPaper from '@/page/byl/org/examination_paper/model'
import PageOrgExamPaperList from '@/page/byl/org/examination_paper/list'
import PageOrgExamPaperScoreList from '@/page/byl/org/examination_paper/scoreList'
import PageOrgExamPaperScoreByTeacher from '@/page/byl/org/examination_paper/scoreByTeacher'
import PageOrgExamPaperAnswerList from '@/page/byl/org/examination_paper/answerList'
import PageOrgExamClassification_f from '@/page/byl/org/examination_paper/classification_f'
import PageOrgExamClassification_s from '@/page/byl/org/examination_paper/classification_s'
import PageOrgExamClassification_relate from '@/page/byl/org/examination_paper/classification_relate'

import PageOrgExamQuestionList from '@/page/byl/org/examination_question/list'
import PageOrgExamQ_ShortAnswer from '@/page/byl/org/examination_question/model_shortAnswer'
import PageOrgExamQ_Judgment from '@/page/byl/org/examination_question/model_judgment'
import PageOrgExamQ_Completion from '@/page/byl/org/examination_question/model_completion'
import PageOrgExamQ_Choice from '@/page/byl/org/examination_question/model_choice'
import PageOrgExamQ_MultipleChoice from '@/page/byl/org/examination_question/model_multipleChoice'

import PageOrgExamQClassification_f from '@/page/byl/org/examination_question/classification_f'
import PageOrgExamQClassification_s from '@/page/byl/org/examination_question/classification_s'
import PageOrgExamQClassification_relate from '@/page/byl/org/examination_question/classification_relate'

import PageOrgQuestionnaire from '@/page/byl/org/questionnaire/model'
import PageOrgQuestionnaireStat from '@/page/byl/org/questionnaire/statistics'
import PageOrgQuestionnaireList from '@/page/byl/org/questionnaire/list'
/* 考试-考卷-考题-问卷--end */
import PageOrgTeacher from '@/page/byl/org/teacher/model'
import PageOrgTeacherList from '@/page/byl/org/teacher/list'
import PageOrgEnroll from '@/page/byl/org/enroll/model'
import PageOrgEnrollList from '@/page/byl/org/enroll/list'
import PageOrgEnrollConfirm from '@/page/byl/org/enroll/confirm'
import PageOrgEnrollAudit from '@/page/byl/org/enroll/audit'
import PageOrgEnrollCheck from '@/page/byl/org/enroll/check'
import PageOrgCert from '@/page/byl/org/cert/model'
import PageOrgCertList from '@/page/byl/org/cert/list'
import PageOrgSendCert from '@/page/byl/org/cert/send'
import PageOrgPlan from '@/page/byl/org/plan/model'
import PageOrgPlanList from '@/page/byl/org/plan/list'
import PageOrgInformation from '@/page/byl/org/information/model'
import PageOrgInformationList from '@/page/byl/org/information/list'
import PageUserList from '@/page/byl/org/user/list'
import PageOrgInfo from '@/page/byl/org/orginfo/list'

import ModuleTeacherDetail from '@/page/entrain/teacher/model'

import TaskList from '@/page/entrain/task/index'
import CourseList from '@/page/entrain/course/list'
import Course from '@/page/entrain/course/model'
import LivePlayList from '@/page/entrain/liveplay/list'
import LivePlay from '@/page/entrain/liveplay/model'
import PlanList from '@/page/entrain/plan/list'
import Plan from '@/page/entrain/plan/detail'
import PlanRecord from '@/page/entrain/plan/record'
import EnrollList from '@/page/entrain/enroll/list'
import Enroll from '@/page/entrain/enroll/detail'
import myCourse from '@/page/modules/task/myCourse'
import myPlan from '@/page/modules/task/myPlan'
import myEnroll from '@/page/modules/task/myEnroll'
import myExamination from '@/page/modules/task/myExam'
import myQuiz from '@/page/modules/task/myQTest'
import UC from '@/page/entrain/uc/index'
import Record from '@/page/modules/uc/record'
import Fav from '@/page/modules/uc/fav'
import Examination from '@/page/modules/uc/examination'
import EnrollUC from '@/page/modules/uc/enroll'
import Certificate from '@/page/modules/uc/certificate'
import Message from '@/page/modules/uc/message'
import Set from '@/page/modules/uc/Set'
import Order from '@/page/modules/uc/Order'
import Invoice from '@/page/modules/uc/invoice'
import LearnRecord from '@/page/modules/uc/learnrecord'

const routes = [
  {
    path: '/entrain/index',
    component: Index,
    redirect: '/entrain/home',
    children: [
      {
        path: '/entrain/home',
        name: '企业内训首页',
        component: Home
      },
      {
        path: '/entrain/wxPay',
        name: '微信支付(企业内训)',
        component: ModuleWXPay
      },
      {
        path: '/entrain/payResult/:type/:businessId/:res_url',
        name: '购买结果(企业内训)',
        component: ModulePayResult
      },
      {
        path: '/entrain/courseList',
        name: '线上课程',
        component: CourseList
      },
      {
        name: '线上课程详情',
        path: '/entrain/courseDetail/:id',
        component: Course,
        meta: {
          navClass: '/entrain/courseList' // 为了实现点击到详情页时维持顶部导航栏选中的状态
        }
      },
      {
        path: '/entrain/coursePay/:id/:type/:businessId/:orgType/:result_url/:sign',
        name: '课程购买(企业内训)',
        component: ModulePay
      },
      {
        path: '/entrain/livePlayList',
        name: '直播课程',
        component: LivePlayList
      },
      {
        name: '直播课程详情（企业内训）',
        path: '/entrain/livePlayDetail/:id',
        component: LivePlay,
        meta: {
          navClass: '/entrain/liveplayList' // 为了实现点击到详情页时维持顶部导航栏选中的状态
        }
      },
      {
        path: '/entrain/livePlayPay/:id/:type/:businessId/:orgType/:result_url/:sign',
        name: '直播购买(企业内训)',
        component: ModulePay,
        meta: {
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/teacherDetail/:id',
        name: '讲师详情(企业内训)',
        component: ModuleTeacherDetail,
        meta: {
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/planList',
        name: '培训计划(企业内训前台)',
        component: PlanList
      },
      {
        name: '培训计划详情(企业内训前台)',
        path: '/entrain/plan/:id',
        component: Plan,
        meta: {
          navClass: '/entrain/planList' // 为了实现点击到详情页时维持顶部导航栏选中的状态
        }
      },
      {
        name: '培训计划进度(企业内训前台)',
        path: '/entrain/planrecord/:id/:planId',
        component: PlanRecord,
        meta: {
          navClass: '/entrain/planList' // 为了实现点击到详情页时维持顶部导航栏选中的状态
        }
      },
      {
        path: '/entrain/planPay/:id/:type/:businessId/:orgType/:result_url/:sign',
        name: '培训计划购买(企业内训前台)',
        component: ModulePay,
        meta: {
          navClass: '/entrain/planList' // 为了实现点击到详情页时维持顶部导航栏选中的状态
        }
      },
      {
        path: '/entrain/examReady/:id/:type',
        name: '开始考试(企业内训)',
        component: ModuleExamReady
      },
      {
        path: '/entrain/examStart/:id/:examId',
        name: '考试页面(企业内训)',
        component: ModuleExamStart
      },
      {
        path: '/entrain/questionnaireStart/:id/:type/:paperId',
        name: '问卷页面(企业内训)',
        component: ModuleQuestionnaireStart
      },
      {
        path: '/entrain/questionnaireResult/:id/:type',
        name: '问卷结果(企业内训)',
        component: ModuleQuestionnaireResult
      },
      {
        path: '/entrain/examAnalysis/:id/:examId/:infoId',
        name: '考试分析(企业内训)',
        component: ModuleExamAnalysis
      },
      {
        path: '/entrain/examResult/:examId',
        name: '考试结果(企业内训)',
        component: ModuleExamResult
      },
      {
        path: '/entrain/enrollList',
        name: '报名中心(企业内训前台)',
        component: EnrollList,
        meta: {
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/enroll/:id',
        name: '报名(企业内训前台)',
        component: Enroll,
        meta: {
          navClass: '/entrain/enrollList', // 为了实现点击到详情页时维持顶部导航栏选中的状态
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/enrollPay/:id/:type/:businessId/:orgType/:result_url/:sign',
        name: '报名购买(企业内训前台)',
        component: ModulePay,
        meta: {
          navClass: '/entrain/enrollList', // 为了实现点击到详情页时维持顶部导航栏选中的状态
          prefix: '/entrain'
        }
      },
      {
        name: '任务中心1',
        path: '/entrain/taskList',
        component: TaskList,
        redirect: '/entrain/taskList/course',
        children: [
          {
            path: '/entrain/taskList/course',
            name: 'myCourse1',
            component: myCourse
          },
          {
            path: '/entrain/taskList/plan',
            name: 'myPlan1',
            component: myPlan
          },
          {
            path: '/entrain/taskList/exam',
            name: 'myExamination1',
            component: myExamination
          },
          {
            path: '/entrain/taskList/quiz',
            name: 'myQuiz1',
            component: myQuiz
          },
          {
            path: '/entrain/taskList/enroll',
            name: 'myEnroll1',
            component: myEnroll,
            meta: {
              prefix: '/entrain'
            }
          }
        ]
      },
      {
        path: '/entrain/uc',
        name: '企业内训个人中心',
        component: UC,
        children: [
          {
            path: '/entrain/uc/record',
            name: '企业内训个人中心学习记录',
            component: Record
          },
          {
            path: '/entrain/uc/fav',
            name: '企业内训个人中心我的收藏',
            component: Fav
          },
          {
            path: '/entrain/uc/examination',
            name: '企业内训个人中心我的考试',
            component: Examination
          },
          {
            path: '/entrain/uc/enroll',
            name: '企业内训个人中心我的报名',
            component: EnrollUC,
            meta: {
              prefix: '/entrain'
            }
          },
          {
            path: '/entrain/uc/certificate',
            name: '企业内训个人中心我的证书',
            component: Certificate
          },
          {
            path: '/entrain/uc/message',
            name: '企业内训个人中心我的消息',
            component: Message
          },
          {
            path: '/entrain/uc/set',
            name: '企业内训个人中心系统设置',
            component: Set
          },
          {
            path: '/entrain/uc/order',
            name: '企业内训个人中心我的订单',
            component: Order,
            meta: {
              prefix: '/entrain'
            }
          },
          {
            path: '/entrain/uc/invoice',
            name: '企业内训个人中心我的开票',
            component: Invoice,
            meta: {
              prefix: '/entrain'
            }
          },
          {
            path: '/entrain/uc/lrecord',
            name: '企业内训个人中心我的学时',
            component: LearnRecord,
            meta: {
              prefix: '/entrain'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/entrain/org',
    component: PageOrg,
    redirect: '/entrain/org/entinfo',
    children: [
      {
        path: '/entrain/org/structure',
        name: '组织架构（企业内训）',
        component: PageOrgStructure,
        meta: {
          title: '组织架构',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/reports',
        name: '报表预览（企业内训）',
        component: PageOrgReports,
        meta: {
          title: '报表预览',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/externals',
        name: '外部系统(企业内训)',
        component: PageOrgExternals,
        meta: {
          title: '外部系统',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/group',
        name: '小组管理（企业内训）',
        component: PageOrgGroup,
        meta: {
          title: '小组管理',
          prefix: '/entrain'
        }
      },
      {
        name: '消息管理(企业内训)',
        path: '/entrain/org/msgList',
        component: PageOrgMsgList,
        meta: {
          title: '消息管理',
          prefix: '/entrain'
        }
      },
      {
        name: '消息发送（企业内训）',
        path: '/entrain/org/msg',
        component: PageOrgMsg,
        meta: {
          title: '消息发送',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/tag/:id',
        name: '标签详情(企业内训)',
        component: PageOrgTag,
        meta: {
          title: '标签管理',
          description: '标签管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/tagList',
        name: '标签管理(企业内训)',
        component: PageOrgTagList,
        meta: {
          title: '标签管理',
          description: '标签管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/resource/:id',
        name: '课件资源详情（企业内训）',
        component: PageOrgResource,
        meta: {
          title: '课件资源管理',
          description: '课件资源管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/resourceList',
        name: '课件资源管理（企业内训）',
        component: PageOrgResourceList,
        meta: {
          title: '课件资源管理',
          description: '课件资源管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/repo/:id',
        name: '知识库详情（企业内训）',
        component: PageOrgRepo,
        meta: {
          title: '知识库管理',
          description: '知识库管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/repoList',
        name: '知识库管理（企业内训）',
        component: PageOrgRepoList,
        meta: {
          title: '知识库管理',
          description: '知识库管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/course/:id',
        name: '课程编辑（企业内训）',
        component: PageOrgCourse,
        meta: {
          title: '课程管理',
          description: '课程管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/courseList',
        name: '课程管理（企业内训）',
        component: PageOrgCourseList,
        meta: {
          title: '课程管理',
          description: '课程管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/livePlay/:id',
        name: '直播编辑（企业内训）',
        component: PageOrgLivePlay,
        meta: {
          title: '直播管理',
          description: '直播管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/livePlayList',
        name: '直播管理（企业内训）',
        component: PageOrgLivePlayList,
        meta: {
          title: '直播管理',
          description: '直播管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/questionnaire/:id',
        name: '问卷编辑（企业内训）',
        component: PageOrgQuestionnaire,
        meta: {
          title: '问卷管理',
          description: '问卷管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/questionnaireStat/:id',
        name: '问卷统计（企业内训）',
        component: PageOrgQuestionnaireStat,
        meta: {
          title: '问卷管理',
          description: '问卷管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/questionnaireList',
        name: '问卷管理（企业内训）',
        component: PageOrgQuestionnaireList,
        meta: {
          title: '问卷管理',
          description: '问卷管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examPaper/:id',
        name: '考卷编辑（企业内训）',
        component: PageOrgExamPaper,
        meta: {
          title: '考卷管理',
          description: '考卷管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examPaperList',
        name: '考卷管理（企业内训）',
        component: PageOrgExamPaperList,
        meta: {
          title: '考卷管理',
          description: '考卷管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examPaperScoreList/:id',
        name: '考卷成绩一览（企业内训）',
        component: PageOrgExamPaperScoreList,
        meta: {
          title: '考卷成绩一览',
          description: '考卷成绩一览',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examPaperScoreByTeacher/:examId/:paperId',
        name: '老师评分（企业内训）',
        component: PageOrgExamPaperScoreByTeacher,
        meta: {
          title: '老师评分',
          description: '老师评分',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examPaperAnswerList/:id',
        name: '考卷成绩回答一览（企业内训）',
        component: PageOrgExamPaperAnswerList,
        meta: {
          title: '考卷成绩回答一览',
          description: '考卷成绩回答一览',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examClassification_f/:path/:id',
        name: '大分类管理（企业内训）',
        component: PageOrgExamClassification_f,
        meta: {
          title: '大分类管理',
          description: '大分类管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examClassification_s/:path/:id',
        name: '小分类管理（企业内训）',
        component: PageOrgExamClassification_s,
        meta: {
          title: '小分类管理',
          description: '小分类管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examClassification_relate/:path/:id/:fValue/:fLabel',
        name: '分类关联（企业内训）',
        component: PageOrgExamClassification_relate,
        meta: {
          title: '分类关联',
          description: '分类关联',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examQuestionList',
        name: '考题管理（企业内训）',
        component: PageOrgExamQuestionList,
        meta: {
          title: '考题管理',
          description: '考题管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examQClassification_f/:path/:id',
        name: '考题大分类管理(企业内训)',
        component: PageOrgExamQClassification_f,
        meta: {
          title: '大分类管理',
          description: '大分类管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examQClassification_s/:path/:id',
        name: '考题小分类管理(企业内训)',
        component: PageOrgExamQClassification_s,
        meta: {
          title: '小分类管理',
          description: '小分类管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examQClassification_relate/:path/:id/:fValue/:fLabel',
        name: '考题分类关联(企业内训)',
        component: PageOrgExamQClassification_relate,
        meta: {
          title: '分类关联',
          description: '分类关联',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examQuestionShortAnswer/:id',
        name: '简答题编辑（企业内训）',
        component: PageOrgExamQ_ShortAnswer,
        meta: {
          title: '简答题编辑',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examQuestionCompletion/:id',
        name: '填空题编辑（企业内训）',
        component: PageOrgExamQ_Completion,
        meta: {
          title: '填空题编辑',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examQuestionChoice/:id',
        name: '选择题编辑（企业内训）',
        component: PageOrgExamQ_Choice,
        meta: {
          title: '选择题编辑',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examQuestionJudgment/:id',
        name: '判断题编辑（企业内训）',
        component: PageOrgExamQ_Judgment,
        meta: {
          title: '判断题编辑',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/examQuestionMultipleChoice/:id',
        name: '多选题编辑（企业内训）',
        component: PageOrgExamQ_MultipleChoice,
        meta: {
          title: '多选题编辑',
          prefix: '/entrain'
        }
      },
      {
        name: '培训计划管理（企业内训）',
        path: '/entrain/org/planList',
        component: PageOrgPlanList,
        meta: {
          title: '培训计划管理',
          description: '培训计划管理',
          prefix: '/entrain'
        }
      },
      {
        name: '培训计划详情（企业内训）',
        path: '/entrain/org/plan/:id',
        component: PageOrgPlan,
        meta: {
          title: '培训计划管理',
          description: '培训计划管理',
          prefix: '/entrain'
        }
      },
      {
        name: '报名管理（企业内训）',
        path: '/entrain/org/enrollList',
        component: PageOrgEnrollList,
        meta: {
          title: '报名管理',
          description: '报名管理',
          prefix: '/entrain'
        }
      },
      {
        name: '报名管理详情（企业内训）',
        path: '/entrain/org/enroll/:id',
        component: PageOrgEnroll,
        meta: {
          title: '报名管理',
          description: '报名管理',
          prefix: '/entrain'
        }
      },
      {
        name: '报名人员列表（企业内训）',
        path: '/entrain/org/enrollConfirm/:id',
        component: PageOrgEnrollConfirm,
        meta: {
          title: '报名管理',
          description: '报名管理',
          prefix: '/entrain'
        }
      },
      {
        name: '报名审核（企业内训）',
        path: '/entrain/org/enrollAudit/:id',
        component: PageOrgEnrollAudit,
        meta: {
          title: '报名审核',
          description: '报名审核',
          prefix: '/entrain'
        }
      },
      {
        name: '报名签到（企业内训）',
        path: '/entrain/org/enrollCheck/:id',
        component: PageOrgEnrollCheck,
        meta: {
          title: '报名签到',
          description: '报名签到',
          prefix: '/entrain'
        }
      },
      {
        name: '证书管理（企业内训）',
        path: '/entrain/org/certList',
        component: PageOrgCertList,
        meta: {
          title: '证书管理',
          description: '证书管理',
          prefix: '/entrain'
        }
      },
      {
        name: '证书管理详情（企业内训）',
        path: '/entrain/org/cert/:id',
        component: PageOrgCert,
        meta: {
          title: '证书管理',
          description: '证书管理',
          prefix: '/entrain'
        }
      },
      {
        name: '发证书(企业内训)',
        path: '/entrain/org/sendcert',
        component: PageOrgSendCert,
        meta: {
          title: '发证书',
          description: '发证书',
          prefix: '/entrain'
        }
      },
      {
        name: '讲师管理（企业内训）',
        path: '/entrain/org/teacherList',
        component: PageOrgTeacherList,
        meta: {
          title: '讲师管理',
          description: '讲师管理',
          prefix: '/entrain'
        }
      },
      {
        name: '讲师管理详情（企业内训）',
        path: '/entrain/org/teacher/:id',
        component: PageOrgTeacher,
        meta: {
          title: '讲师管理',
          description: '讲师管理',
          prefix: '/entrain'
        }
      },
      {
        name: '公告管理（企业内训）',
        path: '/entrain/org/informationList',
        component: PageOrgInformationList,
        meta: {
          title: '公告管理',
          description: '公告管理',
          prefix: '/entrain'
        }
      },
      {
        name: '公告管理详情（企业内训）',
        path: '/entrain/org/information/:id',
        component: PageOrgInformation,
        meta: {
          title: '公告管理',
          description: '公告管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/bannerList',
        name: '推荐列表（企业内训）',
        component: PageOrgBannerList,
        meta: {
          title: '推荐管理',
          description: '推荐管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/banner/:id',
        name: '推荐详情（企业内训）',
        component: PageOrgBanner,
        meta: {
          title: '推荐管理',
          description: '推荐管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/menuList',
        name: '菜单管理（企业内训）',
        component: PageMenuList,
        meta: {
          title: '菜单管理',
          description: '菜单管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/menu/:id/:parentId',
        name: '菜单管理详情（企业内训）',
        component: PageMenu,
        meta: {
          title: '菜单管理',
          description: '菜单管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/orgroleList',
        name: '机构角色管理（企业内训）',
        component: PageOrgRoleList,
        meta: {
          title: '机构角色管理',
          description: '机构角色管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/orgrole/:id',
        name: '机构角色编辑(企业内训)',
        component: PageOrgRole,
        meta: {
          title: '机构角色编辑',
          description: '机构角色编辑',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/orgrole/distribute/:id',
        name: '机构角色分配管理(企业内训)',
        component: PageOrgRoleDistributeList,
        meta: {
          title: '机构角色分配管理',
          description: '机构角色分配管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/roleList',
        name: '角色管理（企业内训）',
        component: PageRoleList,
        meta: {
          title: '角色管理',
          description: '角色管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/role/:id',
        name: '角色管理详情（企业内训）',
        component: PageRole,
        meta: {
          title: '角色管理',
          description: '角色管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/role/distribute/:id',
        name: '角色管理分配（企业内训）',
        component: PageRoleDistributeList,
        meta: {
          title: '角色管理',
          description: '角色管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/dictList',
        name: '字典管理（企业内训）',
        component: PageDictList,
        meta: {
          title: '字典管理',
          description: '字典管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/dict/:id',
        name: '字典管理详情（企业内训）',
        component: PageDict,
        meta: {
          title: '字典管理',
          description: '字典管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/userList',
        name: '用户管理（企业内训）',
        component: PageUserList,
        meta: {
          title: '用户管理',
          description: '用户管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/entinfo',
        name: '机构信息管理(企业内训)',
        component: PageOrgInfo,
        meta: {
          title: '机构信息管理',
          description: '机构信息管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/appmgtList',
        name: 'APP管理(企业内训)',
        component: PageOrgAppList,
        meta: {
          title: 'APP管理',
          description: 'APP管理',
          prefix: '/entrain'
        }
      },
      {
        path: '/entrain/org/appmgt/:id',
        name: 'APP版本编辑(企业内训)',
        component: PageOrgApp,
        meta: {
          title: 'APP版本编辑',
          description: 'APP版本编辑',
          prefix: '/entrain'
        }
      }
    ]
  }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/router-entrain.js